<template>
    <div>
        <p>读取给定地址的文件夹的文件，获取文件清单</p>
        <el-input placeholder="请输入要读取的文件夹的地址" v-model="path" clearable>
        </el-input>

        <el-button type="primary" @click="getlistfiles">获取</el-button>

    </div>
</template>

<script>
export default {
    data() {
        return {
            path: ''
        }
    },
    methods: {
        getlistfiles() {
            this.$axios.post(url + "getlistfiles", { path: this.path }, { responseType: "blob" })
                .then(
                    res => {
                        let url = URL.createObjectURL(res.data);
                        let link = document.createElement("a");
                        link.download ="Listfiles.xlsx";
                        link.href = url;
                        link.click();
                    }

                )
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/exceltodb/listfiles.vue